import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppConfig } from '../../../config/app';
import { AuthApi } from '../../../providers/api-provider';
import { Loader, showError, showSuccess, simpleInputStateHandler } from '../libs/helpers';
import styles from './styles/login';
/* ResetPassword Component */
class ResetPasswordRequest extends React.Component {
  state = {
    email: '',
    loading: false,
  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /* API Call */
  performSendResetLink = async () => {
    if (this.state.email) {
      await this.setState({ loading: true });
      try {
        await AuthApi.resetPasswordRequest(this.state.email);
        showSuccess('Check out your inbox please!');
      } catch (e) {
        showError(e);
        this.setState({ loading: false });
      }
    } else
      showError('Please fill up the email field');
    this.setState({ loading: false });
  }
  onChange = simpleInputStateHandler;
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */

  /* Render Page */
  render() {
    const { loading } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <main className={classes.main}>
          <CssBaseline />
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <img alt='edSeed Logo ' src={AppConfig.base+'/logo.png?v1'} style={{ width: '95%' }} />
            </Avatar>
            <Typography variant="body" style={{ width: '100%' }}>
              Please enter your email to search for your account and send a reset link.
            </Typography>
            <FormControl margin="normal" fullWidth error={false}>
              <InputLabel htmlFor="email">Email Address</InputLabel>
              <Input id="email" name="email" autoComplete="email" type='email' autoFocus onChange={this.onChange('email')} />
            </FormControl>
            <Button
              disabled={loading}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={(e) => { e.preventDefault(); this.performSendResetLink(); }}
            >
              {loading ? <Loader size='20' /> : 'Send Reset Email'}
            </Button>
          </Paper>

        </main>

      </div>

    );
  }
}

ResetPasswordRequest.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(ResetPasswordRequest));